import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {
  SimpleManifestEditorClient,
  simpleManifestEditorApiRef,
} from './api/SimpleManifestEditorApi';

export const simpleManifestEditorPlugin = createPlugin({
  id: 'simple-manifest-editor',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: simpleManifestEditorApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, identityApi, fetchApi }) =>
        new SimpleManifestEditorClient({
          discoveryApi,
          identityApi,
          fetchApi,
        }),
    }),
  ],
});

export const SimpleManifestEditorPage = simpleManifestEditorPlugin.provide(
  createRoutableExtension({
    name: 'SimpleManifestEditorPage',
    component: () =>
      import('./components/StandaloneSimpleManifestEditorPage').then(
        m => m.StandaloneSimpleManifestEditorPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const EntitySimpleManifestEditorContent =
  simpleManifestEditorPlugin.provide(
    createComponentExtension({
      name: 'EntitySimpleManifestEditorContent',
      component: {
        lazy: () =>
          import('./components/EntitySimpleManifestEditorContent').then(
            m => m.EntitySimpleManifestEditorContent,
          ),
      },
    }),
  );
